<app-summary *ngIf="entity" [expandable]="true" [expanded]="expanded" (expandedEvent)="onExpanded()">
    <strong title *ngIf="!hideTitle">
        <ng-container *ngIf="summary.description">
            {{summary.description}}:
        </ng-container>
        <app-price-label [price]="summary.amount"></app-price-label>
    </strong>
    <ng-container content>
        <div class="d-flex w-100">
            <div class="flex-grow-0 d-flex gap-4 flex-wrap align-items-center">
                <app-summary-field *ngIf="hideTitle && summary.description" [value]="summary.description"></app-summary-field>
                <app-summary-field *ngIf="hideTitle">
                    <app-price-label [price]="summary.amount"></app-price-label>
                </app-summary-field>

                <app-summary-field [value]="'#' + summary.id"></app-summary-field>
                <app-summary-field [value]="summary.status?.label" *ngIf="!summary.paymentDate"></app-summary-field>
                <app-summary-field>
                    Demandé le <app-date-label [date]="summary.createdAt"></app-date-label>
                </app-summary-field>
                <app-price-summary-field
                        *ngIf="summary.status.value !== PaymentRequestStatus.PAYMENT_REQUEST_STATUS_PAID && summary.status.value !== PaymentRequestStatus.PAYMENT_REQUEST_STATUS_WIL_NOT_PAY"
                        [price]="summary.balance" label="Balance"></app-price-summary-field>
                <app-partner-summary-field [partnerSummary]="summary.partner"></app-partner-summary-field>
                <app-sale-summary-field [entity]="plain?.sale"></app-sale-summary-field>
                <app-summary-field *ngIf="summary.deadline">
                    Date limite de paiement
                    <app-date-label [date]="summary.deadline"></app-date-label>
                </app-summary-field>
                <app-summary-field *ngIf="summary.paymentDate && summary.accountingMovements.length === 0" [labelWithValue]="true" label="Payé le">
                    <app-date-label [date]="summary.paymentDate"></app-date-label>
                </app-summary-field>
                <app-lov-value-summary-field *ngIf="summary.thirdPartyPaymentType" label="Payable par" [lovValueSummary]="summary.thirdPartyPaymentType"></app-lov-value-summary-field>
                <app-partner-summary-field label="Assigné à" [partnerSummary]="summary.thirdPartyPartner" *ngIf="summary.thirdPartyPartner"></app-partner-summary-field>
                <app-document-summary-field *ngIf="summary.document" [documentSummary]="summary.document"></app-document-summary-field>
                <app-summary-field *ngIf="!!summary.onlinePaymentUrl" value="Paiement en ligne possible"></app-summary-field>
            </div>
            <div class="flex-grow-0">
                <ng-content select="[buttons]"></ng-content>
            </div>
        </div>
    </ng-container>
    <ng-container expandedContent>
        <app-loading [showText]="false" [loading]="findOneByIdService.loading$ | async"></app-loading>
        <ng-container *ngIf="plain">
            <div>
                <div><strong>Mouvements comptables</strong></div>
                <div *ngIf="summary.accountingMovements?.length == 0">
                    Aucun mouvement comptable
                </div>
                <ng-container *ngFor="let mvt of summary.accountingMovements; let i = index">
                    <ng-container *ngIf="i === 0 && summary.accountingMovements.length > 1">
                        <br/>
                    </ng-container>
                    <app-summary-field>
                        <app-price-label [price]="mvt.amount"></app-price-label>
                        payé par <strong>{{mvt.paymentType.label.toLowerCase()}}</strong> le <app-date-label [date]="mvt.date"></app-date-label>
                        <ng-container *ngIf="mvt.bankCheck">
                            de <strong>{{mvt.bankCheck.from}}</strong> avec n°<strong>{{mvt.bankCheck.number}}</strong>
                        </ng-container>
                    </app-summary-field>
                </ng-container>
            </div>
            <div *ngIf="plain.groupedChildren?.length > 0">
                <app-expandable-content>
                    <strong title>Paiements regroupés</strong>
                    <app-payment-request-summary *ngFor="let child of plain.groupedChildren" [entity]="child" [expanded]="false"></app-payment-request-summary>
                </app-expandable-content>
            </div>
            <div>
                <strong>Rappels</strong>
                <div *ngIf="plain.reminders.length === 0">
                    Aucun rappel envoyé pour l'instant
                </div>
                <app-payment-request-reminder-item *ngFor="let reminder of plain.reminders" [entity]="reminder"></app-payment-request-reminder-item>
            </div>
        </ng-container>
    </ng-container>
</app-summary>
